import { PrescribedItemErrors } from '../../types/prescription'
import { AustralianState } from '../../types'

export const initFormError: PrescribedItemErrors = {
  patientInstructions: {
    showError: false,
    message: 'Please enter directions',
  },
  reasonForPrescribing: {
    showError: false,
    message: 'Please enter reason for prescribing',
  },
}

export const RTPM_CHECK_REQUIRED_STATE = [
  AustralianState.WesternAustralia,
  AustralianState.Victoria,
  AustralianState.SouthAustralia,
  AustralianState.NorthernTerritory,
  AustralianState.Queensland,
  AustralianState.Tasmania,
]

export const RTPM_SYSTEM_MAPPING = {
  [AustralianState.AustralianCapitalTerritory]: 'Canberra Script',
  [AustralianState.NewSouthWales]: 'SafeScript NSW',
  [AustralianState.NorthernTerritory]: 'NTScript',
  [AustralianState.Queensland]: 'QScript',
  [AustralianState.WesternAustralia]: 'ScriptCheckWA',
  [AustralianState.Tasmania]: 'TasScript',
  [AustralianState.Victoria]: 'SafeScript',
  [AustralianState.SouthAustralia]: 'ScriptCheck SA',
}
